import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState, } from "react";
import { DropdownContainer } from "./styles";
import { createPortal } from "react-dom";
import { AnimatePresence } from "framer-motion";
export var Dropdown = forwardRef(function Dropdown(_a, ref) {
    var anchor = _a.anchor, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, children = _a.children, props = __rest(_a, ["anchor", "isOpen", "setIsOpen", "children"]);
    var _b = useState(null), position = _b[0], setPosition = _b[1];
    var _c = useState(false), internalOpen = _c[0], setInternalOpen = _c[1];
    var dropdownRef = ref || useRef(null);
    var anchorElement = document.getElementById(anchor);
    var anchorRect = anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.getBoundingClientRect();
    useEffect(function () {
        var listenerElement = document.getElementById(anchor);
        var toggleDropdown = function () {
            setIsOpen
                ? setIsOpen(function (state) { return !state; })
                : setInternalOpen(function (state) { return !state; });
        };
        if (listenerElement) {
            listenerElement.addEventListener("click", toggleDropdown);
        }
        return function () {
            if (listenerElement) {
                listenerElement.removeEventListener("click", toggleDropdown);
            }
        };
    }, []);
    useEffect(function () {
        if (isOpen !== undefined) {
            setInternalOpen(isOpen);
        }
    }, [isOpen]);
    useEffect(function () {
        if (anchorRect) {
            setPosition({
                top: anchorRect.top + anchorRect.height + 4,
                right: window.innerWidth - anchorRect.right,
                width: anchorRect.width,
                maxHeight: window.innerHeight - anchorRect.bottom - 12,
            });
        }
    }, [internalOpen]);
    useEffect(function () {
        var handleClickOutside = function (event) {
            var _a;
            if (dropdownRef &&
                // @ts-ignore
                !((_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) &&
                !(anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.contains(event.target))) {
                setIsOpen ? setIsOpen(false) : setInternalOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef, anchorElement]);
    return createPortal(_jsx(AnimatePresence, { children: position && internalOpen && (_jsx(DropdownContainer, __assign({ initial: { height: 0 }, animate: { height: "auto" }, exit: { height: 0 }, transition: { duration: 0.3 }, top: position.top, right: position.right, minWidth: position.width, maxHeight: position.maxHeight, ref: dropdownRef }, props, { children: children }))) }), document.body);
});
//# sourceMappingURL=index.js.map